/**
 * i18n 国际化配置
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import zhCN from './zh-CN'
import enUS from './en-US'

// 支持的语言列表
export const LANGUAGES = [
  { code: 'en-US', name: 'English', flag: '🇺🇸' },
  { code: 'zh-CN', name: '简体中文', flag: '🇨🇳' },
] as const

export type LanguageCode = (typeof LANGUAGES)[number]['code']

// 默认语言
export const DEFAULT_LANGUAGE: LanguageCode = 'en-US'

// 语言存储 key
const LANGUAGE_STORAGE_KEY = 'pms-language'

i18n
  // 自动检测用户语言
  .use(LanguageDetector)
  // 将 i18n 实例传递给 react-i18next
  .use(initReactI18next)
  // 初始化配置
  .init({
    resources: {
      'zh-CN': zhCN,
      'en-US': enUS,
    },
    // 默认语言
    fallbackLng: DEFAULT_LANGUAGE,
    // 默认命名空间
    defaultNS: 'common',
    // 命名空间列表
    ns: ['common', 'menu', 'road', 'decision', 'model', 'login', 'system'],
    // 语言检测配置
    detection: {
      // 检测顺序：localStorage，没有缓存时回退到默认英文
      order: ['localStorage'],
      // 缓存到 localStorage
      caches: ['localStorage'],
      // localStorage key
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    // 插值配置
    interpolation: {
      // React 已经做了 XSS 防护，不需要转义
      escapeValue: false,
    },
    // 调试模式（开发环境）
    debug: import.meta.env.DEV,
  })

export default i18n
